"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var message_1 = require("./message");
var shared_1 = require("@formily/shared");
var isValidateEmpty = function (value) {
    if (shared_1.isArr(value)) {
        for (var i = 0; i < value.length; i++) {
            if (shared_1.isValid(value[i]))
                return false;
        }
        return true;
    }
    else {
        return shared_1.isEmpty(value);
    }
};
var getLength = function (value) {
    return shared_1.isStr(value) ? shared_1.stringLength(value) : value ? value.length : 0;
};
var intersection = function (arr1, arr2) {
    return arr1.filter(function (key) { return arr2.includes(key); });
};
var getRuleMessage = function (rule, type, rules) {
    var allRuleKeys = Object.keys(rules || {});
    var currentRuleKeys = Object.keys(rule || {});
    if (shared_1.isFn(rule.validator) ||
        intersection(currentRuleKeys, allRuleKeys).length > 2) {
        if (rule.format) {
            return rule.message || message_1.getMessage(type);
        }
        return message_1.getMessage(type);
    }
    else {
        return rule.message || message_1.getMessage(type);
    }
};
exports.default = {
    required: function (value, rule, rules) {
        if (rule.required === false)
            return '';
        return isValidateEmpty(value) ? getRuleMessage(rule, 'required', rules) : '';
    },
    max: function (value, rule, rules) {
        var length = getLength(value);
        var max = Number(rule.max);
        return length > max ? getRuleMessage(rule, 'max', rules) : '';
    },
    maximum: function (value, rule, rules) {
        return Number(value) > Number(rule.maximum)
            ? getRuleMessage(rule, 'maximum', rules)
            : '';
    },
    exclusiveMaximum: function (value, rule, rules) {
        return Number(value) >= Number(rule.maximum)
            ? getRuleMessage(rule, 'exclusiveMaximum', rules)
            : '';
    },
    minimum: function (value, rule, rules) {
        return Number(value) < Number(rule.minimum)
            ? getRuleMessage(rule, 'minimum', rules)
            : '';
    },
    exclusiveMinimum: function (value, rule, rules) {
        return Number(value) <= Number(rule.minimum)
            ? getRuleMessage(rule, 'exclusiveMinimum', rules)
            : '';
    },
    len: function (value, rule, rules) {
        var length = getLength(value);
        var len = Number(rule.len);
        return length !== len ? getRuleMessage(rule, 'len', rules) : '';
    },
    min: function (value, rule, rules) {
        var length = getLength(value);
        var min = Number(rule.min);
        return length < min ? getRuleMessage(rule, 'min', rules) : '';
    },
    pattern: function (value, rule, rules) {
        if (isValidateEmpty(value))
            return '';
        return !new RegExp(rule.pattern).test(value)
            ? getRuleMessage(rule, 'pattern', rules)
            : '';
    },
    validator: function (value, rule, rules) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!shared_1.isFn(rule.validator)) return [3, 2];
                        return [4, Promise.resolve(rule.validator(value, rule, rules))];
                    case 1:
                        response = _a.sent();
                        if (shared_1.isBool(response)) {
                            return [2, response ? rule.message : ''];
                        }
                        else {
                            return [2, response];
                        }
                        _a.label = 2;
                    case 2: throw new Error("The rule's validator property must be a function.");
                }
            });
        });
    },
    whitespace: function (value, rule, rules) {
        if (rule.whitespace) {
            return /^\s+$/.test(value)
                ? getRuleMessage(rule, 'whitespace', rules)
                : '';
        }
    },
    enum: function (value, rule, rules) {
        var enums = shared_1.toArr(rule.enum);
        return enums.indexOf(value) === -1
            ? getRuleMessage(rule, 'enum', rules)
            : '';
    }
};
